import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ========================================
// ENGLISH (EN) IMPORTS (unchanged – keep all)
import commonEN from './locales/en/common.json';
import loginEN from './locales/en/login.json';
import dashboardEN from './locales/en/dashboard.json';
import staffInformationEn from './locales/en/staffInformation.json';
import identificationDocEn from './locales/en/identificationDoc.json';
import employmentEn from './locales/en/employment.json';
import contactEN from './locales/en/contact.json';
import equipmentEN from './locales/en/equipment.json';
import trainingsEN from './locales/en/training.json';
import medicalEn from './locales/en/medical.json';
import checkoutProcessEN from './locales/en/checkoutProcess.json';
import staffInitiationEN from './locales/en/staffInitiation.json';
import supervisorEn from './locales/en/supervisor.json';
import dutyStationEn from './locales/en/dutyStation.json';
import saveSectionButtonEn from './locales/en/saveSectionButton.json';
import managementDashboardEn from './locales/en/managementDashboard.json';
import assetsEN from './locales/en/assets.json';
import staffListEn from './locales/en/staffList.json';
import trainingAnalyticsEn from './locales/en/trainingAnalytics.json';

import assetFormEN from './locales/en/assetForm.json';
import assetAssignmentEN from './locales/en/assetAssignment.json';
import completedCheckoutsListEN from './locales/en/completedCheckoutsList.json';
import dutyStationManagementEN from './locales/en/dutyStationManagement.json';
import loginPageEN from './locales/en/loginPage.json';
import supervisorManagementEN from './locales/en/supervisorManagement.json';
import rolesEN from './locales/en/roles.json';
import userManagementEN from './locales/en/userManagement.json';

import hrCheckoutStageEN from './locales/en/hrCheckoutStage.json';
import securityCheckoutStageEN from './locales/en/securityCheckoutStage.json';
import ictCheckoutStageEN from './locales/en/ictCheckoutStage.json';
import hrCheckoutDashboardEN from './locales/en/hrCheckoutDashboard.json';
import ictCheckoutDashboardEN from './locales/en/ictCheckoutDashboard.json';
import securityCheckoutDashboardEN from './locales/en/securityCheckoutDashboard.json';

// ========================================
// FRENCH (FR) IMPORTS (unchanged)
import commonFR from './locales/fr/common.json';
import loginFR from './locales/fr/login.json';
import dashboardFR from './locales/fr/dashboard.json';
import staffInformationFr from './locales/fr/staffInformation.json';
import identificationDocFr from './locales/fr/identificationDoc.json';
import employmentFr from './locales/fr/employment.json';
import contactFR from './locales/fr/contact.json';
import equipmentFR from './locales/fr/equipment.json';
import trainingsFR from './locales/fr/training.json';
import medicalFr from './locales/fr/medical.json';
import checkoutProcessFR from './locales/fr/checkoutProcess.json';
import staffInitiationFR from './locales/fr/staffInitiation.json';
import supervisorFr from './locales/fr/supervisor.json';
import dutyStationFr from './locales/fr/dutyStation.json';
import saveSectionButtonFr from './locales/fr/saveSectionButton.json';
import managementDashboardFr from './locales/fr/managementDashboard.json';
import assetsFR from './locales/fr/assets.json';
import staffListFr from './locales/fr/staffList.json';
import trainingAnalyticsFr from './locales/fr/trainingAnalytics.json';

import assetFormFR from './locales/fr/assetForm.json';
import assetAssignmentFR from './locales/fr/assetAssignment.json';
import completedCheckoutsListFR from './locales/fr/completedCheckoutsList.json';
import dutyStationManagementFR from './locales/fr/dutyStationManagement.json';
import loginPageFR from './locales/fr/loginPage.json';
import supervisorManagementFR from './locales/fr/supervisorManagement.json';
import rolesFR from './locales/fr/roles.json';
import userManagementFR from './locales/fr/userManagement.json';

import hrCheckoutStageFR from './locales/fr/hrCheckoutStage.json';
import securityCheckoutStageFR from './locales/fr/securityCheckoutStage.json';
import ictCheckoutStageFR from './locales/fr/ictCheckoutStage.json';
import ictCheckoutDashboardFR from './locales/fr/ictCheckoutDashboard.json';
import hrCheckoutDashboardFR from './locales/fr/hrCheckoutDashboard.json';
import securityCheckoutDashboardFR from './locales/fr/securityCheckoutDashboard.json';

// ========================================
// SPANISH (ES) IMPORTS (unchanged)
import commonES from './locales/es/common.json';
import loginES from './locales/es/login.json';
import dashboardES from './locales/es/dashboard.json';
import staffInformationEs from './locales/es/staffInformation.json';
import identificationDocEs from './locales/es/identificationDoc.json';
import employmentEs from './locales/es/employment.json';
import contactES from './locales/es/contact.json';
import equipmentES from './locales/es/equipment.json';
import trainingsES from './locales/es/training.json';
import medicalEs from './locales/es/medical.json';
import checkoutProcessES from './locales/es/checkoutProcess.json';
import staffInitiationES from './locales/es/staffInitiation.json';
import supervisorEs from './locales/es/supervisor.json';
import dutyStationEs from './locales/es/dutyStation.json';
import saveSectionButtonEs from './locales/es/saveSectionButton.json';
import managementDashboardEs from './locales/es/managementDashboard.json';
import assetsES from './locales/es/assets.json';
import staffListEs from './locales/es/staffList.json';
import trainingAnalyticsEs from './locales/es/trainingAnalytics.json';

import assetFormES from './locales/es/assetForm.json';
import assetAssignmentES from './locales/es/assetAssignment.json';
import completedCheckoutsListES from './locales/es/completedCheckoutsList.json';
import dutyStationManagementES from './locales/es/dutyStationManagement.json';
import loginPageES from './locales/es/loginPage.json';
import supervisorManagementES from './locales/es/supervisorManagement.json';
import rolesES from './locales/es/roles.json';
import userManagementES from './locales/es/userManagement.json';

import hrCheckoutStageES from './locales/es/hrCheckoutStage.json';
import securityCheckoutStageES from './locales/es/securityCheckoutStage.json';
import ictCheckoutStageES from './locales/es/ictCheckoutStage.json';
import ictCheckoutDashboardES from './locales/es/ictCheckoutDashboard.json';
import hrCheckoutDashboardES from './locales/es/hrCheckoutDashboard.json';
import securityCheckoutDashboardES from './locales/es/securityCheckoutDashboard.json';
// ========================================
// RESOURCES CONFIGURATION (unchanged)
const resources = {
    en: {
        common: commonEN,
        login: loginEN,
        dashboard: dashboardEN,
        staffInformation: staffInformationEn,
        identificationDoc: identificationDocEn,
        employment: employmentEn,
        contact: contactEN,
        equipment: equipmentEN,
        training: trainingsEN,
        medical: medicalEn,
        checkoutProcess: checkoutProcessEN,
        staffInitiation: staffInitiationEN,
        supervisor: supervisorEn,
        dutyStation: dutyStationEn,
        saveSectionButton: saveSectionButtonEn,
        managementDashboard: managementDashboardEn,
        assets: assetsEN,
        staffList: staffListEn,
        trainingAnalytics: trainingAnalyticsEn,
        assetForm: assetFormEN,
        assetAssignment: assetAssignmentEN,
        completedCheckoutsList: completedCheckoutsListEN,
        dutyStationManagement: dutyStationManagementEN,
        loginPage: loginPageEN,
        supervisorManagement: supervisorManagementEN,
        roles: rolesEN,
        userManagement: userManagementEN,
        hrCheckoutStage: hrCheckoutStageEN,
        securityCheckoutStage: securityCheckoutStageEN,
        ictCheckoutStage: ictCheckoutStageEN,
        hrCheckoutDashboard: hrCheckoutDashboardEN,
        ictCheckoutDashboard: ictCheckoutDashboardEN,
        securityCheckoutDashboard: securityCheckoutDashboardEN,
    },
    fr: {
        common: commonFR,
        login: loginFR,
        dashboard: dashboardFR,
        staffInformation: staffInformationFr,
        identificationDoc: identificationDocFr,
        employment: employmentFr,
        contact: contactFR,
        equipment: equipmentFR,
        training: trainingsFR,
        medical: medicalFr,
        checkoutProcess: checkoutProcessFR,
        staffInitiation: staffInitiationFR,
        supervisor: supervisorFr,
        dutyStation: dutyStationFr,
        saveSectionButton: saveSectionButtonFr,
        managementDashboard: managementDashboardFr,
        assets: assetsFR,
        staffList: staffListFr,
        trainingAnalytics: trainingAnalyticsFr,
        assetForm: assetFormFR,
        assetAssignment: assetAssignmentFR,
        completedCheckoutsList: completedCheckoutsListFR,
        dutyStationManagement: dutyStationManagementFR,
        loginPage: loginPageFR,
        supervisorManagement: supervisorManagementFR,
        roles: rolesFR,
        userManagement: userManagementFR,
        hrCheckoutStage: hrCheckoutStageFR,
        securityCheckoutStage: securityCheckoutStageFR,
        ictCheckoutStage: ictCheckoutStageFR,
        hrCheckoutDashboard: hrCheckoutDashboardFR,
        ictCheckoutDashboard: ictCheckoutDashboardFR,
        securityCheckoutDashboard: securityCheckoutDashboardFR,
    },
    es: {
        common: commonES,
        login: loginES,
        dashboard: dashboardES,
        staffInformation: staffInformationEs,
        identificationDoc: identificationDocEs,
        employment: employmentEs,
        contact: contactES,
        equipment: equipmentES,
        training: trainingsES,
        medical: medicalEs,
        checkoutProcess: checkoutProcessES,
        staffInitiation: staffInitiationES,
        supervisor: supervisorEs,
        dutyStation: dutyStationEs,
        saveSectionButton: saveSectionButtonEs,
        managementDashboard: managementDashboardEs,
        assets: assetsES,
        staffList: staffListEs,
        trainingAnalytics: trainingAnalyticsEs,
        assetForm: assetFormES,
        assetAssignment: assetAssignmentES,
        completedCheckoutsList: completedCheckoutsListES,
        dutyStationManagement: dutyStationManagementES,
        loginPage: loginPageES,
        supervisorManagement: supervisorManagementES,
        roles: rolesES,
        userManagement: userManagementES,
        hrCheckoutStage: hrCheckoutStageES,
        securityCheckoutStage: securityCheckoutStageES,
        ictCheckoutStage: ictCheckoutStageES,
        hrCheckoutDashboard: hrCheckoutDashboardES,
        ictCheckoutDashboard: ictCheckoutDashboardES,
        securityCheckoutDashboard: securityCheckoutDashboardES, 
    }
};

// ========================================
// I18N INITIALIZATION
// ========================================

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: true,  // Force on for debugging

        ns: [
            'common', 'login', 'dashboard', 'staffInformation', 'identificationDoc', 'employment', 'contact', 'equipment', 'training', 'medical', 'checkoutProcess', 'staffInitiation', 'supervisor', 'dutyStation', 'saveSectionButton', 'managementDashboard', 'assets', 'staffList', 'trainingAnalytics', 'assetForm', 'assetAssignment', 'completedCheckoutsList', 'dutyStationManagement', 'loginPage', 'supervisorManagement', 'roles', 'userManagement', 'hrCheckoutStage', 'securityCheckoutStage', 'ictCheckoutStage', 'hrCheckoutDashboard', 'ictCheckoutDashboard', 'securityCheckoutDashboard',
        ],
        defaultNS: 'common',

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: false,
        },

        load: 'languageOnly',  // NEW: Prioritizes inline resources only (no sub-ns loads)

        initImmediate: false,  // Ensures full load before t() calls
    });

// Enhanced post-init debug (remove after fixing)
i18n.on('initialized', () => {
    console.log('=== i18n Debug: Resources Loaded ===');
    console.log('Available langs:', i18n.languages);
    const testT = i18n.t('header.accessLevel', { role: 'TestRole' }, { lng: 'en' });
    console.log('Raw resource for header.accessLevel:', i18n.getResourceBundle('en', 'userManagement').header?.accessLevel);
    console.log('Interpolated test (EN):', testT);
    if (testT === 'Access Level: TestRole') {
        console.log('✅ Interpolation WORKS! Dynamic should now use "ICT" and "Full Access".');
    } else {
        console.log('❌ Interpolation failed – verify JSON has "Access Level: {role}" exactly.');
    }
});

export default i18n;